import React, { useEffect, useState } from 'react';
import withHeader from '../../../hocs/withHeader';
import SurveysService from "../../../../services/SurveysService";

function SurveyPreviewPage(props) {
    const [surveyName, setSurveyName] = useState('');
    const surveyId = props.match.params.surveyId;
    const myFrameId = "previewIframeId";

    useEffect(()=>{
        SurveysService.getSurveyNameAndStatus(surveyId, (success) => {
            setSurveyName(success.data.name);
        }, (error) =>{
            console.log(error);
        });
    },[]);

    const onEditQuestionClick = () => {
        let iframe = document.getElementById(myFrameId);
        const hiddenIframeElement = iframe.contentWindow.document.getElementById("elementWithQidx");
        const questionId = hiddenIframeElement && hiddenIframeElement.innerText;
        props.history.push("/survey/builder/" + surveyId + "?editQuestion=" + questionId);
    };

    return(
        <div className="questionaire__test">
            <h1 className="questionaire__test__title questionaire__test__title--action pb-md pt-xlg">{surveyName}</h1>
            <a href="#" className="questionaire__test__action pt-sm" onClick={(event) =>{event.preventDefault();onEditQuestionClick();}}>
                <img src="/assets/img/builder/action_edit-dark.png" alt=""/>
                EDIT QUESTION
            </a>
            <div className="questionaire__test__question">
                <iframe id={myFrameId} className="questionaire__test__iframe" src={"/polls/"+ surveyId}/>
            </div>
        </div>
    )
}

export default withHeader(SurveyPreviewPage);
